"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnMenuSizeMap = void 0;
exports.columnMenuSizeMap = Object.freeze({
    sm: '185px',
    md: '205px',
    lg: '250px',
    xl: '320px'
});
